module.exports = __webpack_public_path__ + "assets/img/71d4-nc.svg";